import { render } from "./App.vue?vue&type=template&id=4e9571ba&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4e9571ba&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9571ba"]])

export default __exports__